import React, {useEffect, useRef} from "react";

const Modal = ({
                 closeModal,
                 values,
                 parentId,
                 onItemClick,
                 tooltip
               }) => {
  const modalBody = useRef();
  const dialogRef = useRef();

  useEffect(() => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
    }
  }, []);

  const handleButtonClick = ({parentId, id, is_selected}) => {
    if (values.find(value => value.is_selected).id !== 'chk_none') {
      closeModal();
    } else {
      onItemClick({parentId, id, is_selected});
    }
  }

  return (
    <dialog
      ref={dialogRef}
      id="configurator-modal-datacheck"
      className="fixed inset-0 z-overlay bg-transparent w-full max-w-4xl p-0"
      aria-labelledby="configurator-modal-datacheck-title"
      aria-describedby="configurator-modal-datacheck-descr"
      onClick={(e) => {
        if (modalBody.current && (e.target === modalBody.current || e.target === modalBody.current.parentElement)) {
          closeModal();
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          closeModal();
        }
      }}
    >
      <div
        ref={modalBody}
        className="relative overflow-hidden bg-white shadow w-full tablet:max-h-[calc(100vh-5rem)]"
      >
        <div
          className="sticky top-0 h-[55px] flex items-center justify-between bg-brand-1 pl-2xl pr-sm"
        >
          <div id="configurator-modal-datacheck-title" className="font-semibold text-base text-white">
            {Drupal.t('Artwork Check Service')}
          </div>
          <button
            onClick={() => closeModal()}
            type="button"
            className="bg-transparent border-none rounded-full h-xl w-xl"
            aria-label={Drupal.t('Close')}
          >
            <ft-icon color="white" name="close" width={24} height={24}></ft-icon>
          </button>
        </div>
        <div className="bg-white w-full p-xl overflow-y-auto overflow-x-hidden max-h-[calc(100vh-4rem)] tablet:max-h-[calc(100vh-9rem)]">
          <div id="configurator-modal-datacheck-descr" className="tooltip-wrapper" dangerouslySetInnerHTML={{
            __html: tooltip,
          }}>
          </div>
          <div className="flex flex-col items-center mt-xl">
            <ft-button
              variant="1"
              size="big"
              onClick={() => handleButtonClick({
                parentId,
                id: values.find(value => value.id !== 'chk_none').id,
                is_selected: values.find(value => value.id !== 'chk_none').is_selected
              })}
            >
              {Drupal.t('Add Artwork Check')}
            </ft-button>
          </div>
        </div>
      </div>
    </dialog>
  );
};

export default Modal;
